(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecocut-information"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.type !== 'file') return;
  const preview = input.closest('[data-logo-preview]');
  if (!preview) return;
  const logo = preview.querySelector('[data-logo-image]');
  const status = preview.querySelector('[data-logo-status]');
  const previous = logo.getAttribute('href');
  logo.removeAttribute('href');
  if (previous) URL.revokeObjectURL(previous);
  const file = input.files?.[0];
  status.textContent = '';
  if (!file) return;
  if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type) || file.size > 10000000) {
    status.textContent = 'Kies een PNG, JPG of WebP van maximaal 10 MB.';
    return;
  }
  logo.setAttribute('href', URL.createObjectURL(file));
  status.textContent = 'Je logo staat op de impressie. Het bestand blijft op dit apparaat.';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
